// สร้างอัตโนมัติโดย scripts/clone-site.js
const menu = {
 "left": [
  {
   "key": "home",
   "href": "/",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-esports-checked.png",
   "label": "ยอดนิยม"
  },
  {
   "key": "slot",
   "href": "/slot",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-itpslot-checked.png",
   "label": "สล็อตเกม"
  },
  {
   "key": "casino",
   "href": "/casino",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-card-checked.png",
   "label": "คาสิโนสด"
  },
  {
   "key": "sport",
   "href": "/sport",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-sportsbook-check.png",
   "label": "กีฬา"
  },
  {
   "key": "lotto",
   "href": "/lotto",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-lotto-checked.png",
   "label": "หวย"
  },
  {
   "key": "keno",
   "href": "/keno",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-ufaslot-checked.png",
   "label": "คีโน"
  },
  {
   "key": "crash",
   "href": "/crash",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-esports-checked.png",
   "label": "เกมกราฟ"
  },
  {
   "key": "cards",
   "href": "/cards",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-card-checked.png",
   "label": "เกมไพ่"
  },
  {
   "key": "demo",
   "href": "/demo",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/12/icn-lc-checked.png",
   "label": "ทดลองเล่น"
  }
 ],
 "right": [
  {
   "key": "home",
   "href": "/",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/05/5235.png",
   "label": "หน้าหลัก"
  },
  {
   "key": "promotion",
   "href": "/promotions",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/05/tab_promotion.png",
   "label": "โปรโมชั่น"
  },
  {
   "key": "article",
   "href": "/article",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/03/menu-hot-ic.png",
   "label": "บทความ"
  },
  {
   "key": null,
   "href": "https://lin.ee/jPLucp7",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2021/07/line.png",
   "label": "Line"
  },
  {
   "key": null,
   "href": "https://www.facebook.com/profile.php?id=100057318682654",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/04/1024px-Facebook_Logo_2019.png",
   "label": "Facebook"
  },
  {
   "key": "review",
   "href": "/review",
   "img": "/local-assets/ideabet.fun/theme/betflix1688/wp-content/uploads/2022/05/download-1.png",
   "label": "รีวิว"
  }
 ]
};
export default menu;
